import {
  FormControl,
  InputAdornment,
  InputAdornmentProps,
  Typography,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { DatePicker as MuiDatePicker } from "@mui/x-date-pickers/DatePicker";
import { frFR } from "@mui/x-date-pickers/locales";
import { fr } from "date-fns/locale";
import React, { useEffect, useState } from "react";
import { FieldMetaState, FieldRenderProps } from "react-final-form";
import { formatApiDate } from "../../helpers/formatters";
import CalendarIcon from "../../ressources/images/CalendarSVG";
//import CalendarIcon from "../../ressources/images/calendar-icon.svg";
import { isValid } from "date-fns";
import { gris2, gris3 } from "../../theme";
import messages from "./messages";
import styles from "./styles";

const frenchLocale =
  frFR.components.MuiLocalizationProvider.defaultProps.localeText;
interface Props {
  variante?: "inline" | "dialog";
  isYearMonth?: boolean;
  isYear?: boolean;
  varianteInput?: "filled" | "outlined" | "standard";
  label: string;
  required?: boolean;
  disabled?: boolean;
  maxDate?: Date;
  minDate?: Date;
  minDateMessage?: string;
  maxDateMessage?: string;
  invalidDateMessage?: string;
  input?: any;
  meta: FieldMetaState<string>;
  onBlur?: () => void;
}

function CustomInputAdornment(props: InputAdornmentProps) {
  const { children, sx, ...other } = props;
  return (
    <InputAdornment {...other}>
      <CalendarIcon />
      {children}
    </InputAdornment>
  );
}

const InputCalendrier: React.FC<
  Props & FieldRenderProps<any, HTMLElement, any>
> = ({
  variante,
  varianteInput,
  label,
  required = false,
  disabled = false,
  input,
  maxDate,
  minDate,
  meta,
  isYearMonth,
  isYear,
  minDateMessage,
  maxDateMessage,
  invalidDateMessage,
  onBlur,
}) => {
  const [dateSelectionnee, setDateSelectionnee] = useState<Date | null>(
    input?.value ? new Date(input.value) : null
  );

  const handleDateChange = (date: Date | null) => {
    let isValidDate = date && isValid(date);

    setDateSelectionnee(date);
    const newDate = isValidDate && formatApiDate(date);

    input.onChange(!isValidDate ? null : newDate);
  };

  const handleError = (date: string | null) => {
    // if (input && !date) {
    //   input.onChange("");
    // }
  };

  useEffect(() => {
    if (input.value) {
      setDateSelectionnee(new Date(input.value));
    }
  }, [input.value]);
  const commonProps = {
    autoOk: true,
    label,
    value: dateSelectionnee,
    onError: handleError,
    onBlur,
    minDate: minDate || undefined,
    maxDate: maxDate || new Date(),
    variant: variante,
    inputVariant: varianteInput,
    className: "datepicker",
    InputProps: {
      inputProps: {
        className: "input",
        underline: "underline",
      },
    },
    InputLabelProps: {
      className: "inputLabel",
      focused: "inputLabelFocused",
      error: "inputLabelError",
      asterisk: "inputLabelAsterisk",
      shrink: "inputLabelShrink",
    },
    required,
    disabled,
    // format: isYearMonth || isYear ? undefined : dateFormat,
    invalidDateMessage: invalidDateMessage || messages.invalidDateMessage,
    minDateMessage: !(meta.touched && !!meta.error)
      ? minDateMessage || messages.minDateMessage
      : "",
    maxDateMessage: !(meta.touched && !!meta.error)
      ? maxDateMessage || messages.maxDateMessage
      : "",
    error: meta.touched && !!meta.error,
    slotProps: {
      toolbar: {
        hidden: false,
      },
      layout: {
        sx: {
          background: gris3,
          "& .MuiPickersToolbar-root": {
            background: gris2,
            "& span": {
              display: "none",
            },
            "& .MuiDatePickerToolbar-title": {
              color: "white",
              fontWeight: "400",
              fontSize: 30,
            },
          },
        },
      },
    },
  };

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={fr}
      // Define the translations to have the right placeholders (for example `JJJJ` for the year).
      localeText={frenchLocale}
    >
      <FormControl className="root" sx={styles}>
        {isYear ? (
          <MuiDatePicker
            {...commonProps}
            views={["year"]}
            onChange={handleDateChange}
          />
        ) : isYearMonth ? (
          <MuiDatePicker
            {...commonProps}
            views={["month", "year"]}
            onChange={handleDateChange}
          />
        ) : (
          <MuiDatePicker
            {...commonProps}
            onChange={handleDateChange}
            slots={{ openPickerIcon: CalendarIcon }}
          />
        )}
        {(meta.touched || meta.active || meta.dirty) && meta.error && (
          <Typography color="error" variant="caption">
            {meta.error}
          </Typography>
        )}
      </FormControl>
    </LocalizationProvider>
  );
};

export default InputCalendrier;
